module.exports = __webpack_public_path__ + "static/background-89320c3cce77285fc6291891e7f93595.mp4";